var _defs, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVipNew(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "none",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: 1,
    y1: 1,
    x2: 0,
    y2: 0.2101779580116272,
    id: "master_svg0_11_2550"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FF6812",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FFD25E",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 1,
    y1: 1,
    x2: 0,
    y2: 0.2101779580116272,
    id: "master_svg1_11_2550"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FF6812",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FFD25E",
    stopOpacity: 1
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "passthrough"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "passthrough"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "passthrough"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.475,2L1,5.986000000000001L8,14L8,2L3.475,2Z",
    fillRule: "evenodd",
    fill: "url(#master_svg0_11_2550)",
    fillOpacity: 1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.800000011920929,
      mixBlendMode: "passthrough"
    },
    transform: "matrix(-1,0,0,1,30,0)"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.475,2L15,5.986000000000001L22,14L22,2L17.475,2Z",
    fillRule: "evenodd",
    fill: "url(#master_svg1_11_2550)",
    fillOpacity: 1
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVipNew);
export default __webpack_public_path__ + "static/media/vip-new.192dac5a.svg";
export { ForwardRef as ReactComponent };